import { Cookies } from 'react-cookie';

export class CookieManager {

    public static setSession(value: string) {

        const cookies = new Cookies();
        const date = new Date();

        cookies.remove("_session");
        date.setDate(date.getDate() + 2);

        cookies.set("_session", value,
            {
                path: "/",
                expires: date
            });
    }

    public static getSession(): string {

        const cookies = new Cookies();
        const value = cookies.get("_session");

        return value;
    }

    public static clearSession() {

        const cookies = new Cookies();
        cookies.remove("_session");
        
    }

}


// WEBPACK FOOTER //
// ./src/core/utility/CookieManager.tsx